import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "regles-pastilles-group" }
const _hoisted_4 = { class: "bouton-avec-regle btn-contacter" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "info-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_StatusFournisseurTag = _resolveComponent("StatusFournisseurTag")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_AreaText = _resolveComponent("AreaText")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('facture.title')) + " " + _toDisplayString(this.numeroFacture) + " ", 1),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_ReglePastille, { cle: "facturesFournisseur.definition" }),
          _createVNode(_component_ReglePastille, { cle: "factureFournisseurDetail.historiqueRejets" }),
          _createVNode(_component_ReglePastille, { cle: "factureFournisseurDetail.reglementsListe" })
        ])
      ])
    ]),
    _createVNode(_component_BorderedIconButton, {
      imgUrl: _ctx.imgUrl,
      onClick: this.$router.back,
      className: "back-btn",
      title: "RETOUR"
    }, null, 8, ["imgUrl", "onClick"]),
    _createElementVNode("span", _hoisted_4, [
      _createVNode(_component_BorderedIconButton, {
        imgUrl: _ctx.imgContactUrl,
        onClick: _ctx.contacter,
        title: _ctx.$t('facture.fournisseur.contacter.bouton')
      }, null, 8, ["imgUrl", "onClick", "title"]),
      _createVNode(_component_ReglePastille, { cle: "factureFournisseurDetail.contacterRecipient" })
    ]),
    (_ctx.status !== null)
      ? (_openBlock(), _createBlock(_component_StatusFournisseurTag, {
          key: 0,
          status: this.status
        }, null, 8, ["status"]))
      : _createCommentVNode("", true),
    (this.factureData && this.isLoaded)
      ? (_openBlock(), _createBlock(_component_DataList, {
          key: 1,
          data: this.factureData,
          "stop-propa-on-pdf": true,
          onSelect: _ctx.goToPage
        }, null, 8, ["data", "onSelect"]))
      : _createCommentVNode("", true),
    (_ctx.isAttachmentLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.modalContacterOpen)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCard, {
              activeValidate: _ctx.isFormValid,
              headerTitle: _ctx.$t('contact.page.title'),
              onCancel: _ctx.annuler,
              onConfirm: _ctx.envoyer
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_TextInput, {
                    modelValue: _ctx.objet,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objet) = $event)),
                    class: "input-objet",
                    label: "Objet"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_AreaText, {
                    id: "sujetTextarea",
                    modelValue: _ctx.sujet,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sujet) = $event)),
                    class: "areaText",
                    label: "Sujet"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.isFactureRejetee
                            ? _ctx.$t('facture.fournisseur.modal.comptabilite')
                            : _ctx.$t('facture.fournisseur.modal.assistante') + ' - ') + _toDisplayString(_ctx.nom.toUpperCase()) + " " + _toDisplayString(_ctx.prenom
                            .split(' ')
                            .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                            .join(' ')), 1)
              ]),
              _: 1
            }, 8, ["activeValidate", "headerTitle", "onCancel", "onConfirm"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}